import React from 'react';

interface BrandLogoProps {
  size?: 'sm' | 'md' | 'lg';
}

export const BrandLogo: React.FC<BrandLogoProps> = ({ size = 'md' }) => {
  const dim = size === 'sm' ? 28 : size === 'md' ? 36 : 48;

  return (
    <div className="relative flex items-center justify-center shrink-0">
      <svg
        width={dim}
        height={dim}
        viewBox="0 0 100 100"
        className="transition-transform duration-300 hover:scale-105"
      >
        <defs>
          <radialGradient id="logoBall" cx="35%" cy="35%" r="65%">
            <stop offset="0%" stop-color="#f5ff82" />
            <stop offset="60%" stop-color="#ccff00" />
            <stop offset="100%" stop-color="#88b300" />
          </radialGradient>
          <linearGradient id="ringGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stop-color="#38bdf8" />
            <stop offset="100%" stop-color="#10b981" />
          </linearGradient>
        </defs>

        {/* Outer Hexagon / Shield Ring */}
        <circle cx="50" cy="50" r="46" fill="#091326" stroke="url(#ringGrad)" strokeWidth="3" />
        
        {/* Court Service Box Cross */}
        <line x1="50" y1="15" x2="50" y2="85" stroke="#334155" strokeWidth="1.5" strokeDasharray="3 3" />
        <line x1="20" y1="50" x2="80" y2="50" stroke="#334155" strokeWidth="1.5" />

        {/* Tennis Ball */}
        <circle cx="50" cy="50" r="26" fill="url(#logoBall)" />

        {/* Ball Curved Seams */}
        <path
          d="M 30 36 C 42 42, 42 58, 30 64"
          fill="none"
          stroke="#ffffff"
          strokeWidth="2.5"
          strokeLinecap="round"
        />
        <path
          d="M 70 36 C 58 42, 58 58, 70 64"
          fill="none"
          stroke="#ffffff"
          strokeWidth="2.5"
          strokeLinecap="round"
        />

        {/* Little Gold Crown / Star */}
        <polygon
          points="50,14 52,19 57,20 53,23 54,28 50,25 46,28 47,23 43,20 48,19"
          fill="#f59e0b"
        />
      </svg>
    </div>
  );
};
